// @ts-nocheck
import useHeaderOpacity from "@store/Framework/Store/Bunzl/Components/Header/Hooks/useHeaderOpacity";
import React from "react";

export interface ResolveHeaderOpacity {
    setFullOpacity: (value: boolean) => void;
}

export default <P extends ResolveHeaderOpacity>(Component: React.ComponentType<P>) => {
    return (props: Omit<P, keyof ResolveHeaderOpacity>) => {
        const { manuallySetFullOpacity } = useHeaderOpacity();

        return <Component {...(props as P)} setFullOpacity={manuallySetFullOpacity} />;
    };
};
